/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';

import { CoreDataModule } from '@gh/core-data';
import { BuilderContactsRoutingModule } from './builder-contacts-routing.module';

import {
  ContactDetailsBusinessService,
  ContactDetailsCityCountyTabComponent,
  ContactDetailsCommonTabComponent,
  ContactDetailsCreditorCommonTabComponent,
  ContactDetailsCreditorDestinationComponent,
  ContactDetailsCreditorSubContractorTabComponent,
  ContactDetailsCreditorTabComponent,
  ContactDetailsCustomerAdditionalDetailsTabComponent,
  ContactDetailsCustomerCommonTabComponent,
  ContactDetailsCustomerRelativeComponent,
  ContactDetailsCustomerTabComponent,
  ContactDetailsDebtorCommonTabComponent,
  ContactDetailsDebtorTabComponent,
  ContactDetailsEmployeeCommonTabComponent,
  ContactDetailsEmployeeTabComponent,
  ContactDetailsFinanceCompanyCommonTabComponent,
  ContactDetailsFinanceCompanyTabComponent,
  ContactDetailsOtherTabComponent,
  ContactDetailsSharedCommunicationListTabComponent,
  ContactDetailsSharedCustomFieldsTabComponent,
  ContactDetailsSharedPortalTabComponent,
  ContactDetailsSharedTermsPayeeTabComponent,
  ContactDetailsSharedTermsPayerTabComponent,
  ContactDetailsTabContainerComponent,
  ContactDuplicatesDialogComponent,
} from './contact-details';
import { ContactListBusinessService, ContactListComponent } from './contact-list';

@NgModule({
  imports: [
    CoreDataModule.forChild(),
    BuilderSharedModule.forChild(),

    BuilderContactsRoutingModule,
  ],
  providers: [
    ContactListBusinessService,
    ContactDetailsBusinessService,
  ],
  declarations: [
    ContactDetailsTabContainerComponent,
    ContactDetailsCommonTabComponent,
    ContactDetailsEmployeeTabComponent,
    ContactDetailsEmployeeCommonTabComponent,
    ContactDuplicatesDialogComponent,
    ContactListComponent,
    ContactDetailsSharedCustomFieldsTabComponent,
    ContactDetailsCreditorTabComponent,
    ContactDetailsCreditorCommonTabComponent,
    ContactDetailsCreditorDestinationComponent,
    ContactDetailsCreditorSubContractorTabComponent,
    ContactDetailsCustomerTabComponent,
    ContactDetailsCustomerCommonTabComponent,
    ContactDetailsDebtorTabComponent,
    ContactDetailsDebtorCommonTabComponent,
    ContactDetailsSharedTermsPayerTabComponent,
    ContactDetailsSharedTermsPayeeTabComponent,
    ContactDetailsSharedCommunicationListTabComponent,
    ContactDetailsFinanceCompanyCommonTabComponent,
    ContactDetailsFinanceCompanyTabComponent,
    ContactDetailsCityCountyTabComponent,
    ContactDetailsOtherTabComponent,
    ContactDetailsSharedPortalTabComponent,
    ContactDetailsCustomerAdditionalDetailsTabComponent,
    ContactDetailsCustomerRelativeComponent,
  ],
  entryComponents: [
    ContactDuplicatesDialogComponent,
    ContactDetailsCommonTabComponent,
    ContactDetailsEmployeeTabComponent,
    ContactDetailsCityCountyTabComponent,
    ContactDetailsEmployeeCommonTabComponent,
    ContactDetailsCreditorTabComponent,
    ContactDetailsCreditorCommonTabComponent,
    ContactDetailsCreditorSubContractorTabComponent,
    ContactDetailsCustomerTabComponent,
    ContactDetailsCustomerCommonTabComponent,
    ContactDetailsDebtorTabComponent,
    ContactDetailsDebtorCommonTabComponent,
    ContactDetailsFinanceCompanyCommonTabComponent,
    ContactDetailsFinanceCompanyTabComponent,
    ContactDetailsOtherTabComponent,
    ContactDetailsSharedCustomFieldsTabComponent,
    ContactDetailsSharedTermsPayerTabComponent,
    ContactDetailsSharedTermsPayeeTabComponent,
    ContactDetailsSharedCommunicationListTabComponent,
    ContactDetailsSharedPortalTabComponent,
    ContactDetailsCustomerAdditionalDetailsTabComponent,
  ],
})
export class BuilderContactsModule {
}
